export const FIELD_TYPE = {
    PHONE_COUNTRY: 'phone_country',
    PHONE: 'phone',
    PHONE_STRICT: 'phone_strict',
    TEL: 'tel',
    EMAIL: 'email',
    TEXT: 'text',
    TEXTAREA: 'textarea',
    PAN: 'pan',
    CVV: 'cvv',
    EXP_DATE: 'exp_date',
    CHECK_BOX: 'check_box',
    CHECKBOX: 'checkbox',
    COUNTRY: 'country',
    DATE: 'date',
    BANK_ACCOUNT: 'bank_account',
    DROP_BOX: 'drop_box',
    DROP_BOX_MODAL: 'drop_box_modal',
    SBP_DROP_BOX: 'sbp_drop_box',
    ZIP: 'zip',
    BIK: 'bik',
    AUTOCOMPLETE_ADDRESS: 'autocomplete_address',
    AUTOCOMPLETE_POST_CODE: 'autocomplete_post_code',
    ALIPAY_FREE: 'alipay_free',
    UPLOAD_DOC: 'upload_doc',
    ATTACHMENT: 'attachment',
    MASTERCARD_FREE: 'mastercard_free',
    FILE: 'file',
    SEPA_FREE: 'sepa_free',
    HIDDEN: 'hidden',
    DEVICE_SCREEN_HEIGHT: 'device_screen_height',
    DEVICE_SCREEN_WIDTH: 'device_screen_width',
    SCREEN_HEIGHT: 'screen_height',
    SCREEN_WIDTH: 'screen_width',
} as const;

export type FieldTypeKey = keyof typeof FIELD_TYPE;
export type FieldTypeValue = (typeof FIELD_TYPE)[FieldTypeKey];

const {
    PHONE_COUNTRY,
    PHONE,
    PHONE_STRICT,
    TEL,
    EMAIL,
    TEXT,
    TEXTAREA,
    PAN,
    CVV,
    EXP_DATE,
    CHECK_BOX,
    CHECKBOX,
    COUNTRY,
    DATE,
    BANK_ACCOUNT,
    DROP_BOX,
    DROP_BOX_MODAL,
    SBP_DROP_BOX,
    ZIP,
    BIK,
    AUTOCOMPLETE_ADDRESS,
    AUTOCOMPLETE_POST_CODE,
    ALIPAY_FREE,
    UPLOAD_DOC,
    ATTACHMENT,
    MASTERCARD_FREE,
    FILE,
    SEPA_FREE,
    HIDDEN,
    DEVICE_SCREEN_HEIGHT,
    DEVICE_SCREEN_WIDTH,
    SCREEN_HEIGHT,
    SCREEN_WIDTH,
} = FIELD_TYPE;

export {
    PHONE_COUNTRY,
    PHONE,
    PHONE_STRICT,
    TEL,
    EMAIL,
    TEXT,
    TEXTAREA,
    PAN,
    CVV,
    EXP_DATE,
    CHECK_BOX,
    CHECKBOX,
    COUNTRY,
    DATE,
    BANK_ACCOUNT,
    DROP_BOX,
    DROP_BOX_MODAL,
    SBP_DROP_BOX,
    ZIP,
    BIK,
    AUTOCOMPLETE_ADDRESS,
    AUTOCOMPLETE_POST_CODE,
    ALIPAY_FREE,
    UPLOAD_DOC,
    ATTACHMENT,
    MASTERCARD_FREE,
    FILE,
    SEPA_FREE,
    HIDDEN,
    DEVICE_SCREEN_HEIGHT,
    DEVICE_SCREEN_WIDTH,
    SCREEN_HEIGHT,
    SCREEN_WIDTH,
};
